/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_A_RefereeInputs */

const th_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีนี้ไม่ใช่ผู้ตัดสิน`)
};

const en_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That account is not a referee.`)
};

const ja_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントは審判ではありません。`)
};

const zh_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该账户不属于裁判。`)
};

const es_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa cuenta no es de un árbitro.`)
};

const pt_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa conta não é de árbitro.`)
};

const id_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun itu bukan milik seorang wasit.`)
};

const fr_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce compte n’est pas celui d’un arbitre.`)
};

const tl_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pag-aari ng referee ang account na iyon.`)
};

const vi_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản đó không thuộc về một trọng tài.`)
};

const ko_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 계정은 심판의 계정이 아닙니다.`)
};

const de_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Konto gehört keinem Schiedsrichter.`)
};

const ru_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот аккаунт не принадлежит судье.`)
};

const tr_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O hesap bir hakeme ait değil.`)
};

const it_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'account non appartiene a un arbitro.`)
};

const pl_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To konto nie należy do sędziego.`)
};

const uk_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей обліковий запис не належить судді.`)
};

const hi_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह खाता किसी रेफ़री का नहीं है।`)
};

const ar_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك الحساب لا يعود لحكم.`)
};

const ms_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun itu bukan milik pengadil.`)
};

const bn_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই অ্যাকাউন্ট কোনও রেফারির নয়।`)
};

const zh_tw2_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那個帳戶不屬於裁判。`)
};

const zh_hk2_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那個帳戶不屬於裁判。`)
};

const ur_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ اکاؤنٹ کسی ریفری کا نہیں۔`)
};

const fa_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن حساب متعلق به داور نیست.`)
};

const sw_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaunti hiyo si ya refa.`)
};

const nl_err_not_a_referee = /** @type {(inputs: Err_Not_A_RefereeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dat account is niet van een scheidsrechter.`)
};

/**
* | output |
* | --- |
* | "That account is not a referee." |
*
* @param {Err_Not_A_RefereeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_a_referee = /** @type {((inputs?: Err_Not_A_RefereeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_A_RefereeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_not_a_referee(inputs)
	if (locale === "ja") return ja_err_not_a_referee(inputs)
	if (locale === "zh") return zh_err_not_a_referee(inputs)
	if (locale === "es") return es_err_not_a_referee(inputs)
	if (locale === "pt") return pt_err_not_a_referee(inputs)
	if (locale === "id") return id_err_not_a_referee(inputs)
	if (locale === "fr") return fr_err_not_a_referee(inputs)
	if (locale === "tl") return tl_err_not_a_referee(inputs)
	if (locale === "vi") return vi_err_not_a_referee(inputs)
	if (locale === "ko") return ko_err_not_a_referee(inputs)
	if (locale === "de") return de_err_not_a_referee(inputs)
	if (locale === "ru") return ru_err_not_a_referee(inputs)
	if (locale === "tr") return tr_err_not_a_referee(inputs)
	if (locale === "it") return it_err_not_a_referee(inputs)
	if (locale === "pl") return pl_err_not_a_referee(inputs)
	if (locale === "uk") return uk_err_not_a_referee(inputs)
	if (locale === "hi") return hi_err_not_a_referee(inputs)
	if (locale === "ar") return ar_err_not_a_referee(inputs)
	if (locale === "ms") return ms_err_not_a_referee(inputs)
	if (locale === "bn") return bn_err_not_a_referee(inputs)
	if (locale === "zh-TW") return zh_tw2_err_not_a_referee(inputs)
	if (locale === "zh-HK") return zh_hk2_err_not_a_referee(inputs)
	if (locale === "ur") return ur_err_not_a_referee(inputs)
	if (locale === "fa") return fa_err_not_a_referee(inputs)
	if (locale === "sw") return sw_err_not_a_referee(inputs)
	if (locale === "nl") return nl_err_not_a_referee(inputs)
	return en_err_not_a_referee(inputs)
});